import './monthlyForm.scss';

import { format } from 'date-fns';
import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router';
// import * as PropTypes from 'prop-types'; 
import * as PropTypes from 'prop-types';
import { IHistory } from '../../../interfaces';
import { QuestionModel } from '../../../model/QuestionModel';
import { getMonthlyFormQuestions, submitMonthlyForm } from '../../../services/monthlyFormService';
import { dispatch, marshallAnswers, checkAnswerForYesOrNo, getPageTitle } from '../../../utils/generalUtils';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Form } from '../../reusableComponents/FormComponents/Form';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { ImageUpload } from '../../reusableComponents/ImageUpload';
import { Loader } from '../../reusableComponents/Loader';
import { RenderQuestion } from '../../reusableComponents/FormComponents/RenderQuestion';
import { MonthlySPCCData } from '../../../constants/generals';
import { MonthlyFormModel } from '../../../model/MonthlyFormModel';  

export interface IMonthlySPCCFormProps extends DispatchProp<any> {
    questions: QuestionModel[];
    type: string;
    date: string;
    plantId: string;
    userUID: string;
    formId: string;
    history: IHistory;
    formInstance: MonthlyFormModel;
    form;
}

export interface IMonthlySPCCFormState {
    date: string;
    isTouched: boolean;
}

export class MonthlySPCCFormImpl extends React.Component<IMonthlySPCCFormProps, IMonthlySPCCFormState> {
    constructor(props: IMonthlySPCCFormProps) {
        super(props);
        this.state = {
            date: props.date, isTouched: false
        };
    }

    loadDefaultValues = () => {
        this.props.questions.forEach(instance => {
            dispatch(actions.change(`forms.monthlySPCCForm.${instance.  props.quesNum}`,
                checkAnswerForYesOrNo(instance.props.answer)));
        });
    }

    promise = async () => {
        await getMonthlyFormQuestions(this.props.type, this.props.formId);
    }

    static defaultProps: IMonthlySPCCFormProps;
    getChildContext() {
        return { formModel: 'forms.monthlySPCCForm' };
    } 

    static childContextTypes = {
        formModel: PropTypes.string
    };
    refs: {
        images: ImageUpload;
    };

    handleFormSubmit = (values) => { 
        var answer = marshallAnswers(values); 
        delete answer[29];
        delete answer[28];
        answer = answer.filter(Boolean); 
       /*  answer.push({
            quesNum: answer.length + 1,
            answer: format(new Date(), 'hh:mm A')
        }); */
        answer[28] = {'quesNum': 29, 'answer': format(new Date(), 'hh:mm A')};   
        const data = {
            UserId: this.props.userUID,
            PlantId: this.props.plantId,
            InspectionID: 'MonthlySPCC',
            followUp_Required: false,
            Completed: true,
            Date: format(new Date(this.props.date), 'MM-DD-YYYY'),
            Answers: answer,
            followUp_form: 0,
            ImageUrls: [],
            DeletedImages : this.props.form.monthlySPCCForm.deletedImages || [],
            SignatureUrls: [],
            AssociatedTo: null 
        }; 
        return submitMonthlyForm(data, this.props.history, this.refs.images.value, this.props.formId);
    }

    renderContent = () => { 
        const Buttons = [ { 
            label : 'Yes',
            value : 'Yes'
        }, 
        {
            label: 'No',
            value: 'No'
        },
        {
            label: 'N/A',
            value: 'N/A'
        }
    ];
        return <Form
            loadDefaultValues={this.loadDefaultValues}
            model="forms.monthlySPCCForm"
            onSubmit={this.handleFormSubmit}
            className="form"
        >            
            {MonthlySPCCData && MonthlySPCCData.map((quesData, index) => (
                <RenderQuestion
                formId={this.props.formId}
                key={index}
                uniqueValue={index}
                quesNo={quesData.Question_Num && quesData.Question_Num.toString()}
                question={quesData.Question}
                questionType={quesData.Questiontype}
                model="monthlySPCCForm"
                CommentQuestionNum={quesData.CommentQuestionNum ? quesData.CommentQuestionNum : null}
                buttons={Buttons}
                customLabel={quesData.customLabel && quesData.customLabel}
            />
            ))
            }
            <ImageUpload
                ref="images"
                multi={true}
                label="Select Images to Upload:"
                defaultValue={this.props.formInstance && this.props.formInstance.props.ImageUrls }
            />
            <FormFooter />
        </Form>;
    }
    render() {
        let pageTitle = `${getPageTitle(this.props.type, 'monthly', this.props.date, 'inspection')} `;
        return < BasePage pageTitle={pageTitle} >
            <Async
                identifier="MonthlyForm"
                promise={this.promise}
                content={this.renderContent()}
                loader={<Loader type="async" />}
                error={<ErrorPage />}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    const type = 'MonthlySPCC';
    const date = ownProps.match.params.date;
    const questions = QuestionModel.getAllByType(type);
    const formInstance = MonthlyFormModel.get(ownProps.match.params.formId); 
    return {
        plantId: ownProps.match.params.plantId,
        questions, type, date,
        userUID: state.login.get('UniqueId'),
        formId: ownProps.match.params.formId,form: state.forms, formInstance
    };
}

export const MonthlySPCCForm = withRouter(connect<{}, {}, IMonthlySPCCFormProps>(mapStateToProps)(MonthlySPCCFormImpl));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/MonthlyForm/MonthlySPCCForm.tsx